import React, { useMemo, useState } from "react"
import { useQuery } from "@tanstack/react-query"
import { agrogestao } from "@/api/agrogestaoClient"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

export default function PartnerSelect({ tipo = "cliente", value, onChange }) {
  const propriedadeId = localStorage.getItem("propriedade_selecionada")
  const [search, setSearch] = useState("")

  const { data: parceiros = [] } = useQuery({
    queryKey: ["parceiros", propriedadeId],
    queryFn: () => propriedadeId ? agrogestao.entities.Parceiro.filter({ propriedade_id: propriedadeId }) : Promise.resolve([]),
    enabled: !!propriedadeId
  })

  const lista = useMemo(() => {
    const base = parceiros.filter(p => (p.tipo || "outro") === tipo)
    if (!search) return base
    const s = search.toLowerCase()
    return base.filter(p => (p.nome_razao || "").toLowerCase().includes(s) || (p.cnpj_cpf || "").toLowerCase().includes(s))
  }, [parceiros, tipo, search])

  return (
    <div className="space-y-2">
      <Label>{tipo === "cliente" ? "Cliente" : tipo === "fornecedor" ? "Fornecedor" : tipo === "transportador" ? "Transportador" : "Parceiro"}</Label>
      <div className="flex gap-2">
        <div className="flex-1">
          <Select value={value || ""} onValueChange={onChange}>
            <SelectTrigger>
              <SelectValue placeholder="Selecione" />
            </SelectTrigger>
            <SelectContent>
              {lista.map(p => {
                const label = (p.nome_razao || p.razao_social || p.nome || p.cnpj_cpf || '').trim()
                const val = label !== '' ? label : String(p.id ?? Math.random())
                return (
                  <SelectItem key={p.id ?? val} value={val}>
                    {(label || 'Parceiro').slice(0, 60)}
                  </SelectItem>
                )
              })}
            </SelectContent>
          </Select>
        </div>
        <Input className="w-48" placeholder="Buscar..." value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>
    </div>
  )
}
